import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  transform(items: any[] | undefined, key: string, sortBy: 'asc' | 'desc' = 'asc'): any[] {
    if (!items || items.length == 0) {
        return [];
    }

    if (sortBy == 'asc') {
        return orderbyAsc(items, key);
    }
    return orderbyDesc(items, key);
  }
}

function orderbyAsc(array: any[], key: string) {
    return array.sort((catA: any, catB: any) => {
        if (catA[key] > catB[key]) {
            return 1;
        } else if (catA[key] < catB[key]) {
            return -1;
        } else {
            return 0;
        }
    });
}

function orderbyDesc(array: any[], key: string) {
    return array.sort((catA: any, catB: any) => {
        catA = String(catA[key]).toUpperCase();
        catB = String(catB[key]).toUpperCase();
        if (catA < catB) {
            return 1;
        } else if (catA > catB) {
            return -1;
        } else {
            return 0;
        }
    });
}
